(function () {

  // ── State ─────────────────────────────────────────────────────────────────
  var currentVariant   = null;
  var currentPaperSize = '';
  var currentProduct   = '';
  var currentLayout    = 'landscape';

  // ── Size normalisation ────────────────────────────────────────────────────
  function normalizeSize(value) {
    if (!value) return '';
    var key = String(value).trim().toLowerCase()
      .replace(/\s+/g, '')
      .replace(/×/g, 'x')
      .replace(/in$/, '');

    var map = {
      '8.5x11':      'ANSIA',
      '11x17':       'ANSIB',
      '17x22':       'ANSIC',
      '24x36':       'ArchD',
      '36x48':       'ArchE',
      '48x60':       'imperial1',
      '56x70':       'imperial2',
      'foldedsmall': 'foldedSmall',
      'foldedlarge': 'foldedLarge',
      'foldedwide':  'foldedWide'
    };
    var result = map[key] || value;
    console.log('[MapSherpa] normalizeSize:', value, '→', result);
    return result;
  }

  // ── SKU fallback ──────────────────────────────────────────────────────────
  function deriveProductIdFromSku(sku, sizeValue, finishValue) {
    if (!sku) return '';
    var base = String(sku).trim();
    if (base.indexOf('-') > -1) return base.split('-')[0];

    var size   = String(sizeValue || '').replace(/\s+/g, '').replace(/x/ig, 'X');
    var finish = String(finishValue || '').replace(/\s+/g, '').toUpperCase();

    if (size) base = base.replace(new RegExp('_' + size + '(_|$)', 'i'), '_');
    ['POLY','RC','BP','MP','TYVEK','WR','PP','PREM','GLOSS','MATTE','LAM','PAPER'].forEach(function (t) {
      base = base.replace(new RegExp('_' + t + '$', 'i'), '');
    });
    if (finish) base = base.replace(new RegExp('_' + finish + '$', 'i'), '');
    return base.replace(/_$/, '');
  }

  // ── Money formatting ──────────────────────────────────────────────────────
  function money(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || '${{amount}}');
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  // ── Status message ────────────────────────────────────────────────────────
  function setMessage(msg, isError) {
    var el = document.getElementById('mapsherpa-message');
    if (!el) return;
    el.textContent = msg || '';
    el.style.color = isError ? '#b00020' : 'inherit';
  }

  // ── Title max length (per product/template/layout) ─────────────────────────
  // Reads the allowed title length from the MapSherpa SDK for the current
  // product, paper size (template), and orientation (layout), then applies
  // it as the maxlength attribute on the title input so the customer cannot
  // type beyond what MapSherpa will accept.
  //
  // Reference implementation this mirrors:
  //   var maxLength = mapsherpa.getMaxTitleLength(sku, template, layout);
  //   if (maxLength > 0) {
  //     $("#options_" + title_optionid + "_text").attr('maxlength', maxLength);
  //   }
  function updateTitleMaxLength(sku, template, layout) {
    var titleInput = document.getElementById('mapsherpa-title');
    if (!titleInput) return;

    if (!window.mapsherpa || typeof mapsherpa.getMaxTitleLength !== 'function') {
      console.warn('[MapSherpa] getMaxTitleLength not available on SDK — skipping maxlength update');
      return;
    }

    try {
      var maxLength = mapsherpa.getMaxTitleLength(sku, template, layout);
      console.log('[MapSherpa] getMaxTitleLength(', sku, ',', template, ',', layout, ') =', maxLength);

      if (maxLength > 0) {
        titleInput.setAttribute('maxlength', maxLength);

        // If existing value is now too long, trim it and update the SDK title
        if (titleInput.value && titleInput.value.length > maxLength) {
          titleInput.value = titleInput.value.slice(0, maxLength);
          if (mapsherpa.setTitle) mapsherpa.setTitle(titleInput.value);
        }

        // Optional helper text under the field showing the limit
        var hint = document.getElementById('mapsherpa-title-maxlength-hint');
        if (hint) {
          hint.textContent = 'Max ' + maxLength + ' characters for this size/orientation.';
        }
      } else {
        // No limit returned — remove any previously set maxlength
        titleInput.removeAttribute('maxlength');
        var hintEl = document.getElementById('mapsherpa-title-maxlength-hint');
        if (hintEl) hintEl.textContent = '';
      }
    } catch (e) {
      console.error('[MapSherpa] Error calling getMaxTitleLength:', e);
    }
  }

  // ── Get MapSherpa hex product ID ──────────────────────────────────────────
  function getProductId(config, variant) {
    if (config.mapsherpaProductId) {
      console.log('[MapSherpa] Using metafield product ID:', config.mapsherpaProductId);
      return config.mapsherpaProductId;
    }
    console.warn('[MapSherpa] mapsherpa.product_id metafield not set — falling back to SKU');
    if (variant && variant.sku) {
      var derived = deriveProductIdFromSku(variant.sku, variant.option1, variant.option2);
      console.log('[MapSherpa] Derived from SKU:', derived);
      return derived;
    }
    return '';
  }

  // ── Get selected Shopify variant ──────────────────────────────────────────
  function getSelectedVariant(config) {
    if (!config || !Array.isArray(config.variants) || config.variants.length === 0) {
      console.error('[MapSherpa] getSelectedVariant: config.variants missing or empty');
      return null;
    }

    var size     = document.getElementById('mapsherpa-size');
    var material = document.getElementById('mapsherpa-material');
    var sizeVal  = size     ? size.value     : '';
    var matVal   = material ? material.value : '';

    var match = config.variants.find(function (v) {
      return String(v.option1 || '') === sizeVal &&
             (!material || String(v.option2 || '') === matVal);
    });

    if (!match) {
      console.warn('[MapSherpa] No exact variant match for size:', sizeVal, 'material:', matVal, '— falling back to first variant');
    }

    return match || config.variants[0] || null;
  }

  // ── Rebuild Finish/material options to only those valid for the selected Size ──
  function updateMaterialOptionsForSize(config, sizeVal) {
    var matEl = document.getElementById('mapsherpa-material');
    if (!matEl || !config || !Array.isArray(config.variants)) return;

    var previousVal = matEl.value;

    // Collect distinct option2 (finish) values among variants matching this size,
    // preserving first-seen order and skipping unavailable variants.
    var validFinishes = [];
    var seen = {};
    config.variants.forEach(function (v) {
      if (String(v.option1 || '') !== sizeVal) return;
      if (v.available === false) return;
      var finish = v.option2;
      if (finish == null || finish === '') return;
      if (!seen[finish]) {
        seen[finish] = true;
        validFinishes.push(finish);
      }
    });

    if (validFinishes.length === 0) {
      console.warn('[MapSherpa] No available finishes found for size:', sizeVal, '— leaving finish options unchanged');
      return;
    }

    // Rebuild <option> list
    matEl.innerHTML = '';
    validFinishes.forEach(function (finish) {
      var opt = document.createElement('option');
      opt.value = finish;
      opt.textContent = finish;
      matEl.appendChild(opt);
    });

    // Keep the previous selection if it's still valid for this size, else default to the first option
    if (previousVal && validFinishes.indexOf(previousVal) !== -1) {
      matEl.value = previousVal;
    } else {
      matEl.selectedIndex = 0;
    }
  }

  // ── Update price display ──────────────────────────────────────────────────
  function updatePrice(config) {
    var variant = getSelectedVariant(config);
    if (!variant) {
      console.error('[MapSherpa] updatePrice: no variant available — cannot update price');
      setMessage('Unable to determine product price. Please refresh the page.', true);
      return;
    }

    currentVariant = variant;

    var priceEl = document.getElementById('mapsherpa-price');
    if (priceEl) {
      try {
        priceEl.innerHTML = money(variant.price, config.moneyFormat);
      } catch (e) {
        console.error('[MapSherpa] updatePrice: error formatting money:', e);
        priceEl.textContent = variant.price != null ? String(variant.price) : '';
      }
    }

    var variantInput = document.getElementById('mapsherpa-selected-variant');
    if (variantInput) variantInput.value = variant.id;
  }

  // ── Get preview URL from MapSherpa proof image ────────────────────────────
  // The MapSherpa SDK sets data-src on .ms-pod-proof-image after the user
  // clicks the Preview button. We read this to store as cart thumbnail.
  // Falls back to constructing from .img_preview data-src if available.
  function getPreviewUrl() {
    var BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

    // Method 1 — proof image set by MapSherpa after Preview click
    var proofImg = document.querySelector('.ms-pod-proof-image');
    if (proofImg) {
      var dataSrc = proofImg.getAttribute('data-src');
      if (dataSrc && dataSrc !== BLANK && dataSrc.indexOf('a_pixel') === -1) {
        console.log('[MapSherpa] Preview URL from .ms-pod-proof-image data-src:', dataSrc);
        return dataSrc;
      }
      var src = proofImg.getAttribute('src');
      if (src && src !== BLANK && src.indexOf('a_pixel') === -1) {
        console.log('[MapSherpa] Preview URL from .ms-pod-proof-image src:', src);
        return src;
      }
    }

    // Method 2 — img_preview element (reference theme pattern)
    var previewImg = document.querySelector('.img_preview');
    if (previewImg) {
      var previewSrc = previewImg.getAttribute('data-src');
      if (previewSrc && previewSrc !== BLANK) {
        console.log('[MapSherpa] Preview URL from .img_preview data-src:', previewSrc);
        return previewSrc;
      }
    }

    // Method 3 — proof detail image
    var proofDetail = document.querySelector('.ms-pod-proof-detail-image');
    if (proofDetail) {
      var detailSrc = proofDetail.getAttribute('data-src') || proofDetail.getAttribute('src');
      if (detailSrc && detailSrc !== BLANK && detailSrc.indexOf('a_pixel') === -1) {
        console.log('[MapSherpa] Preview URL from .ms-pod-proof-detail-image:', detailSrc);
        return detailSrc;
      }
    }

    console.log('[MapSherpa] No preview URL found — user may not have clicked Preview');
    return '';
  }

  // ── addToCart callback ────────────────────────────────────────────────────
  // Passed as 3rd argument to mapsherpa.customize()
  // SDK calls this when user confirms the crop area
  function addToCart(err, printpdf) {
    console.log('[MapSherpa] addToCart callback fired');
    console.log('[MapSherpa] err:', err);
    console.log('[MapSherpa] printpdf:', printpdf);

    if (err) {
      setMessage('Map error: ' + (err.message || err), true);
      console.error('[MapSherpa] addToCart error:', err);
      return;
    }

    if (!printpdf || !printpdf.id) {
      setMessage('No print PDF returned. Please try again.', true);
      console.error('[MapSherpa] printpdf missing or no ID');
      return;
    }

    if (!currentVariant || !currentVariant.id) {
      setMessage('No Shopify variant selected.', true);
      console.error('[MapSherpa] currentVariant not set');
      return;
    }

    setMessage('Adding to cart...');

    // ── Build proof/thumbnail URL from printpdf object ──────────────────
    // Constructs the thumbnail URL directly from the printpdf object
    // returned by the MapSherpa SDK — no Preview button click required.
    //
    // Proof URL format:
    //   {serverUrl}/printpdf/proof
    //     ?bbox=...&scale=...&product=...&template=...
    //     &layout=...&title=...&mode=personalize&width=300&height=200
    //
    // Thumbnail dimensions use paper size aspect ratio:
    //   Landscape: width=300, height calculated from ratio
    //   Portrait:  height=300, width calculated from ratio
    var PAPER_RATIOS = {
      'ANSIA':     { w: 11,  h: 8.5 },
      'ANSIB':     { w: 17,  h: 11  },
      'ANSIC':     { w: 22,  h: 17  },
      'ArchD':     { w: 36,  h: 24  },
      'ArchE':     { w: 48,  h: 36  },
      'imperial1': { w: 60,  h: 48  },
      'imperial2': { w: 70,  h: 56  }
    };

    var ratio  = PAPER_RATIOS[currentPaperSize] || { w: 36, h: 24 };
    var BASE   = 300;
    var thumbW, thumbH;
    if (currentLayout === 'portrait') {
      thumbH = BASE;
      thumbW = Math.round(BASE * (ratio.h / ratio.w));
    } else {
      thumbW = BASE;
      thumbH = Math.round(BASE * (ratio.h / ratio.w));
    }

    // Get server base URL — priority order:
    // 1. window.LongitudeMapSherpaProduct.serverUrl — set by Liquid before
    //    JS runs, always correct for the current environment (staging or
    //    production) based on the theme "Use staging" checkbox setting.
    // 2. mapsherpa.serverUrl — set by SDK after init (same value, slight lag).
    // 3. Hardcoded production fallback — last resort only.
    var globalConfig = window.LongitudeMapSherpaProduct || {};
    var serverUrl = globalConfig.serverUrl
      || (window.mapsherpa && mapsherpa.serverUrl)
      || 'https://ondemand-eastview-live.mapsherpa.com';

    console.log('[MapSherpa] serverUrl resolved to:', serverUrl,
      '(from:', globalConfig.serverUrl ? 'Liquid config' : (window.mapsherpa && mapsherpa.serverUrl ? 'SDK' : 'fallback'), ')');

    var previewUrl = '';

    if (printpdf.bbox && printpdf.product && printpdf.template) {
      // Primary method — all fields available on printpdf object
      var bboxStr = Array.isArray(printpdf.bbox)
        ? printpdf.bbox.join(',')
        : String(printpdf.bbox);

      previewUrl = serverUrl + '/printpdf/proof'
        + '?bbox='     + encodeURIComponent(bboxStr)
        + '&scale='    + (printpdf.scale     || '')
        + '&product='  + (printpdf.product   || '')
        + '&template=' + (printpdf.template  || '')
        + '&layout='   + currentLayout
        + '&title='    + encodeURIComponent(printpdf.title || '')
        + '&mode=personalize'
        + '&width='    + thumbW
        + '&height='   + thumbH;

      if (printpdf.contentid) {
        previewUrl += '&contentid=' + printpdf.contentid;
      }

      console.log('[MapSherpa] Proof URL built from printpdf object:', previewUrl);

    } else {
      // Fallback — read from proof image if user clicked Preview
      previewUrl = getPreviewUrl();
      console.log('[MapSherpa] printpdf missing bbox/product/template — using getPreviewUrl():', previewUrl);
    }

    // Build download URL from printpdf ID
    // No underscore prefix = visible in Shopify admin order detail page
    // Hidden from cart display via main-cart-items.liquid property filter
    var downloadUrl = serverUrl + '/download/' + printpdf.id + '/pdf/0';

    // Build cart payload
    // 'printpdf'      → MapSherpa webhook uses this to generate PDF
    // 'title'         → Custom map title entered by customer
    // 'download_url'  → PDF download link — shows in admin order detail, hidden in cart
    // '_preview_url'  → Cart thumbnail (underscore hides from emails + cart display)
    var payload = {
      id:       Number(currentVariant.id),
      quantity: 1,
      properties: {
        'Printpdf ID':      printpdf.id,
        'Map Title':         printpdf.title || '',
        '_download_url': downloadUrl,   // underscore hides from checkout + cart display
        '_preview_url':  previewUrl
      }
    };

    console.log('[MapSherpa] Cart payload:', JSON.stringify(payload, null, 2));

    // ── Add to Cart event log ───────────────────────────────────────────────
    // Structured, easy-to-filter log entry for the "add to cart" event.
    // Visible in browser console (F12 → Console, filter by [MapSherpa:EVENT]).
    console.log('[MapSherpa:EVENT] add_to_cart', {
      timestamp:    new Date().toISOString(),
      product:      currentProduct,
      paperSize:    currentPaperSize,
      layout:       currentLayout,
      printpdfId:   printpdf.id,
      title:        printpdf.title || '',
      variantId:    currentVariant.id,
      page:         window.location.href
    });

    if (typeof window.fetch !== 'function') {
      console.error('[MapSherpa] window.fetch is not available in this browser');
      setMessage('Your browser is not supported for this feature. Please try a different browser.', true);
      return;
    }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
    .then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          // Shopify returns 422 with a JSON body describing the error
          // (e.g. variant sold out, quantity invalid) — surface that message.
          var shopifyError = (data && (data.description || data.message)) || ('HTTP ' + res.status);
          throw new Error(shopifyError);
        }
        return data;
      }).catch(function (parseErr) {
        // JSON parsing itself failed, or the throw above — normalise into one error
        if (!res.ok) {
          throw new Error('HTTP ' + res.status);
        }
        throw parseErr;
      });
    })
    .then(function (data) {
      console.log('[MapSherpa] Cart add success:', data);
      console.log('[MapSherpa:EVENT] add_to_cart_success', {
        timestamp:  new Date().toISOString(),
        printpdfId: printpdf.id,
        lineItemKey: data.key || null
      });
      window.location.href = '/cart';
    })
    .catch(function (err) {
      setMessage('Could not add to cart. Please try again.', true);
      console.error('[MapSherpa] Cart fetch error:', err);
      console.log('[MapSherpa:EVENT] add_to_cart_failed', {
        timestamp:  new Date().toISOString(),
        printpdfId: printpdf.id,
        error:      err.message || String(err)
      });
    });
  }

  // ── Load map ──────────────────────────────────────────────────────────────
  function loadMap(config) {
    if (!window.mapsherpa) {
      console.error('[MapSherpa] window.mapsherpa not defined');
      setMessage('MapSherpa SDK failed to load.', true);
      return;
    }

    var variant    = getSelectedVariant(config);
    var sizeSelect = document.getElementById('mapsherpa-size');
    var sizeRaw    = sizeSelect ? sizeSelect.value : (variant ? variant.option1 : '');
    var paperSize  = normalizeSize(sizeRaw);
    var productId  = getProductId(config, variant);

    currentVariant   = variant;
    currentPaperSize = paperSize;
    currentProduct   = productId;

    if (!productId || !paperSize) {
      setMessage('MapSherpa product ID or paper size missing.', true);
      console.error('[MapSherpa] Missing productId or paperSize');
      return;
    }

    var fullId = productId + '-' + paperSize;

    console.log('[MapSherpa] ── loadMap() ──────────────────────────');
    console.log('[MapSherpa] productId:  ', productId);
    console.log('[MapSherpa] sizeRaw:    ', sizeRaw);
    console.log('[MapSherpa] paperSize:  ', paperSize);
    console.log('[MapSherpa] layout:     ', currentLayout);
    console.log('[MapSherpa] fullId:     ', fullId);
    console.log('[MapSherpa] ────────────────────────────────────────');

    var loading = document.querySelector('.mapsherpa-map-loading');
    if (loading) loading.style.display = 'none';

    setMessage('Drag to define your print area, then click Continue to next step.');

    try {
      mapsherpa.customize(fullId, {
        element:  'mapsherpa-map-container',
        controls: config.showMapsherpaControls ? 'top' : 'hidden',
        layout:   currentLayout
      }, addToCart);

      var titleInput = document.getElementById('mapsherpa-title');

      // Apply max title length for this product/template/layout combination.
      // Mirrors reference implementation:
      //   var maxLength = mapsherpa.getMaxTitleLength(sku, template, layout);
      //   if (maxLength > 0) { $("#options_..._text").attr('maxlength', maxLength); }
      updateTitleMaxLength(productId, paperSize, currentLayout);

      if (titleInput && titleInput.value && mapsherpa.setTitle) {
        mapsherpa.setTitle(titleInput.value);
      }

    } catch (e) {
      setMessage('Unable to load MapSherpa: ' + e.message, true);
      console.error('[MapSherpa] Exception in loadMap():', e);
    }
  }

  // ── Initialise ────────────────────────────────────────────────────────────
  function init() {
    var root = document.querySelector('[data-mapsherpa-product-root]');
    if (!root) return;
    if (!window.LongitudeMapSherpaProduct) {
      console.error('[MapSherpa] LongitudeMapSherpaProduct not defined');
      return;
    }

    var config = window.LongitudeMapSherpaProduct;
    console.log('[MapSherpa] init() — config:', config);

    currentVariant = getSelectedVariant(config);

    // Ensure the Finish dropdown only shows options valid for the initially selected Size
    var initialSizeEl = document.getElementById('mapsherpa-size');
    if (initialSizeEl) {
      updateMaterialOptionsForSize(config, initialSizeEl.value);
    }

    updatePrice(config);

    // Size change → setPaperSize + update price
    var sizeEl = document.getElementById('mapsherpa-size');
    if (sizeEl) {
      sizeEl.addEventListener('change', function () {
        var newSize = normalizeSize(sizeEl.value);
        console.log('[MapSherpa] Size changed:', sizeEl.value, '→', newSize);
        updateMaterialOptionsForSize(config, sizeEl.value);
        updatePrice(config);
        if (window.mapsherpa && mapsherpa.setPaperSize && newSize !== currentPaperSize) {
          try {
            mapsherpa.setPaperSize(newSize);
            currentPaperSize = newSize;
          } catch (e) {
            console.error('[MapSherpa] setPaperSize failed:', e);
            setMessage('Unable to change paper size. Please refresh and try again.', true);
          }
        }
        updateTitleMaxLength(currentProduct, currentPaperSize, currentLayout);
      });
    }

    // Material change → update price only
    var matEl = document.getElementById('mapsherpa-material');
    if (matEl) {
      matEl.addEventListener('change', function () {
        console.log('[MapSherpa] Material changed:', matEl.value);
        updatePrice(config);
      });
    }

    // Orientation change → setLayout
    var orientEl = document.getElementById('mapsherpa-orientation');
    if (orientEl) {
      orientEl.addEventListener('change', function () {
        currentLayout = orientEl.value;
        console.log('[MapSherpa] Orientation changed:', currentLayout);
        if (window.mapsherpa && mapsherpa.setLayout) {
          try {
            mapsherpa.setLayout(currentLayout);
          } catch (e) {
            console.error('[MapSherpa] setLayout failed:', e);
            setMessage('Unable to change orientation. Please refresh and try again.', true);
          }
        }
        updateTitleMaxLength(currentProduct, currentPaperSize, currentLayout);
      });
    }

    // Title input → setTitle live
    var titleInput = document.getElementById('mapsherpa-title');
    if (titleInput) {
      titleInput.addEventListener('input', function () {
        if (window.mapsherpa && mapsherpa.setTitle) {
          try {
            mapsherpa.setTitle(titleInput.value);
          } catch (e) {
            console.error('[MapSherpa] setTitle failed (live input):', e);
            // Non-blocking — customer can keep typing, title will be re-synced on Add to Cart
          }
        }
      });
    }

    // Preview button → showPreview
    var previewBtn = document.getElementById('mapsherpa-preview');
    if (previewBtn) {
      previewBtn.addEventListener('click', function () {
        console.log('[MapSherpa] Preview clicked');
        if (!window.mapsherpa || typeof mapsherpa.showPreview !== 'function') {
          console.error('[MapSherpa] showPreview not available on SDK');
          setMessage('Preview is unavailable right now. Please refresh and try again.', true);
          return;
        }
        try {
          mapsherpa.showPreview();
        } catch (e) {
          console.error('[MapSherpa] showPreview failed:', e);
          setMessage('Could not generate preview. Please try again.', true);
        }
      });
    }

    // Add to Cart button
    var addBtn = document.getElementById('mapsherpa-add-to-cart');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        console.log('[MapSherpa] Add to Cart button clicked');

        if (!window.mapsherpa) {
          setMessage('MapSherpa API not loaded. Please refresh the page and try again.', true);
          console.error('[MapSherpa] Add to Cart clicked but window.mapsherpa not defined');
          console.log('[MapSherpa:EVENT] add_to_cart_click_failed', {
            timestamp: new Date().toISOString(),
            reason:    'sdk_not_loaded'
          });
          return;
        }

        if (titleInput && mapsherpa.setTitle) {
          try {
            mapsherpa.setTitle(titleInput.value || '');
          } catch (e) {
            console.error('[MapSherpa] setTitle failed before addToCart:', e);
            // Non-blocking — proceed with addToCart anyway
          }
        }

        if (typeof mapsherpa.addToCart === 'function') {
          try {
            console.log('[MapSherpa] Calling mapsherpa.addToCart(true)');
            mapsherpa.addToCart(true);
          } catch (e) {
            console.error('[MapSherpa] mapsherpa.addToCart(true) threw an exception:', e);
            setMessage('Something went wrong adding your map to the cart. Please try again.', true);
            console.log('[MapSherpa:EVENT] add_to_cart_click_failed', {
              timestamp: new Date().toISOString(),
              reason:    'addToCart_exception',
              error:     e.message || String(e)
            });
          }
        } else {
          console.error('[MapSherpa] mapsherpa.addToCart not available');
          setMessage(
            'Please drag to define your print area then click "Continue to next step" on the map.',
            false
          );
          console.log('[MapSherpa:EVENT] add_to_cart_click_failed', {
            timestamp: new Date().toISOString(),
            reason:    'addToCart_not_available'
          });
        }
      });
    }

    // ── Zoom level helpers ──────────────────────────────────────────────────
    // Disable/enable Preview and Add to Cart based on MapSherpa zoom events.
    // Matches reference theme pattern exactly:
    //   zoom-level-too-big   → disable buttons + zoom out
    //   zoom-level-too-small → disable buttons + zoom in
    //   zoom-level-just-right → enable buttons

    function disableButtons() {
      var preview = document.getElementById('mapsherpa-preview');
      var atc     = document.getElementById('mapsherpa-add-to-cart');
      var orient  = document.getElementById('mapsherpa-orientation');
      if (preview) preview.disabled = true;
      if (atc)     atc.disabled     = true;
      if (orient)  orient.disabled  = true;
      setMessage('Zoom in or out to get the right scale for your map.', true);
      console.log('[MapSherpa] Zoom not right — buttons disabled');
    }

    function enableButtons() {
      var preview = document.getElementById('mapsherpa-preview');
      var atc     = document.getElementById('mapsherpa-add-to-cart');
      var orient  = document.getElementById('mapsherpa-orientation');
      if (preview) preview.disabled = false;
      if (atc)     atc.disabled     = false;
      if (orient)  orient.disabled  = false;
      setMessage('Map ready. Drag to define your print area, then click Continue to next step.');
      console.log('[MapSherpa] Zoom just right — buttons enabled');
    }

    function registerZoomEvents() {
      if (!window.mapsherpa || typeof mapsherpa.on !== 'function') {
        console.error('[MapSherpa] Cannot register zoom events — mapsherpa.on not available');
        // Buttons will stay enabled by default if zoom validation can't be wired up
        enableButtons();
        return;
      }

      try {
        // zoom-level-too-big → selection box is too large
        // Auto-zoom out to help user get to the right level
        mapsherpa.on('zoom-level-too-big', function () {
          disableButtons();
          try {
            var map = mapsherpa.getMap && mapsherpa.getMap();
            if (!map || typeof map.getZoom !== 'function') {
              console.error('[MapSherpa] zoom-level-too-big: getMap()/getZoom() unavailable');
              return;
            }
            var zoom   = map.getZoom();
            var center = mapsherpa.getCenter();
            if (!center) {
              console.error('[MapSherpa] zoom-level-too-big: getCenter() returned nothing');
              return;
            }
            mapsherpa.setCenter(center.lat, center.lng, zoom - 1);
            console.log('[MapSherpa] Zoom too big — zoomed out to:', zoom - 1);
          } catch (e) {
            console.error('[MapSherpa] Error handling zoom-level-too-big:', e);
          }
        });

        // zoom-level-too-small → selection box is too small
        // Auto-zoom in to help user get to the right level
        mapsherpa.on('zoom-level-too-small', function () {
          disableButtons();
          try {
            var map = mapsherpa.getMap && mapsherpa.getMap();
            if (!map || typeof map.getZoom !== 'function') {
              console.error('[MapSherpa] zoom-level-too-small: getMap()/getZoom() unavailable');
              return;
            }
            var zoom   = map.getZoom();
            var center = mapsherpa.getCenter();
            if (!center) {
              console.error('[MapSherpa] zoom-level-too-small: getCenter() returned nothing');
              return;
            }
            mapsherpa.setCenter(center.lat, center.lng, zoom + 1);
            console.log('[MapSherpa] Zoom too small — zoomed in to:', zoom + 1);
          } catch (e) {
            console.error('[MapSherpa] Error handling zoom-level-too-small:', e);
          }
        });

        // zoom-level-just-right → enable everything
        mapsherpa.on('zoom-level-just-right', function () {
          enableButtons();
        });

      } catch (e) {
        console.error('[MapSherpa] Failed to register zoom event listeners:', e);
        // Fail safe — don't leave the customer stuck with permanently disabled buttons
        enableButtons();
        setMessage('Zoom validation is unavailable. You can still create your map.', false);
      }
    }

    // Wait for SDK ready before loading map
    function onReady() {
      console.log('[MapSherpa] SDK ready — calling loadMap()');

      try {
        // Register zoom events before loading map
        registerZoomEvents();

        // Disable buttons initially — zoom events will enable them
        // when the scale is correct after the user defines the crop area
        disableButtons();

        loadMap(config);
      } catch (e) {
        console.error('[MapSherpa] Unexpected error during onReady/loadMap:', e);
        setMessage('Something went wrong loading the map. Please refresh the page.', true);
        console.log('[MapSherpa:EVENT] map_init_failed', {
          timestamp: new Date().toISOString(),
          error:     e.message || String(e)
        });
      }
    }

    if (window.mapsherpa) {
      console.log('[MapSherpa] mapsherpa exists, initialized:', mapsherpa.initialized);
      try {
        if (!mapsherpa.initialized && mapsherpa.once) {
          console.log('[MapSherpa] Waiting for initialized event...');

          // Safety timeout — if the SDK never fires "initialized" within 15s,
          // show an error instead of leaving the customer on a blank/loading page forever.
          var initTimedOut = false;
          var initTimeout = window.setTimeout(function () {
            initTimedOut = true;
            console.error('[MapSherpa] Timed out waiting for "initialized" event (15s)');
            setMessage('The map is taking longer than expected to load. Please refresh the page.', true);
            console.log('[MapSherpa:EVENT] map_init_timeout', {
              timestamp: new Date().toISOString()
            });
          }, 15000);

          mapsherpa.once('initialized', function () {
            window.clearTimeout(initTimeout);
            if (initTimedOut) {
              console.warn('[MapSherpa] "initialized" fired after timeout already shown — proceeding anyway');
            }
            onReady();
          });
        } else {
          onReady();
        }
      } catch (e) {
        console.error('[MapSherpa] Error while wiring up SDK ready state:', e);
        setMessage('Unable to initialise the map. Please refresh the page.', true);
      }
    } else {
      setMessage('MapSherpa SDK failed to load. Check client ID in theme settings.', true);
      console.error('[MapSherpa] window.mapsherpa not defined after DOMContentLoaded');
      console.log('[MapSherpa:EVENT] sdk_load_failed', {
        timestamp: new Date().toISOString(),
        page:      window.location.href
      });
    }
  }

  // ── Global safety net ───────────────────────────────────────────────────────
  // Catches any otherwise-unhandled error or promise rejection originating
  // from this script and logs it with a consistent, filterable tag so issues
  // are easy to find in the browser console even if a specific try/catch
  // above didn't anticipate the failure.
  // ── Price List Modal ──────────────────────────────────────────────────────
  // Fetches the pre-built HTML price list file from Shopify theme assets and
  // displays it in a full-screen modal overlay when "Price List" is clicked.
  // The asset filename is set per-product in Theme Customiser → section settings
  // (price_list_asset). If no asset is configured the link is hidden by Liquid
  // so this function will simply find no elements and exit silently.
  function initPriceListModal() {
    var config       = window.LongitudeMapSherpaProduct || {};
    var assetUrl     = config.priceListAssetUrl;
    var link         = document.getElementById('mapsherpa-pricelist-link');
    var modal        = document.getElementById('mapsherpa-pricelist-modal');

    if (!link || !modal || !assetUrl) return;

    var contentEl    = document.getElementById('ms-pl-content');
    var closeBtn     = modal.querySelector('.ms-pl-close');
    var backdrop     = modal.querySelector('.ms-pl-backdrop');
    var loaded       = false;

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();

      // Fetch once — cache result so subsequent opens are instant
      if (!loaded) {
        fetch(assetUrl)
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (html) {
            // Use an iframe so the price list HTML is completely isolated
            // from Dawn's stylesheet — no class name conflicts, no padding
            // overrides. The iframe sizes itself to fit its content via
            // the load event on the iframe element.
            var iframe = document.createElement('iframe');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('scrolling', 'no');
            iframe.style.cssText = 'width:100%;border:none;display:block;min-height:200px;';
            contentEl.innerHTML = '';
            contentEl.appendChild(iframe);

            // Write the full HTML into the iframe document
            iframe.contentDocument.open();
            iframe.contentDocument.write(html);
            iframe.contentDocument.close();

            // Auto-size the iframe height to fit content after render
            function resizeIframe() {
              try {
                var h = iframe.contentDocument.documentElement.scrollHeight
                     || iframe.contentDocument.body.scrollHeight;
                iframe.style.height = (h + 4) + 'px';
              } catch(e) {}
            }
            iframe.addEventListener('load', resizeIframe);
            // Fallback resize after short delay for slower renders
            setTimeout(resizeIframe, 300);

            loaded = true;
          })
          .catch(function (err) {
            contentEl.innerHTML = '<p style="padding:2rem;color:#c00">Could not load price list. Please try again.</p>';
            console.error('[MapSherpa] Price list fetch failed:', err);
          });
      }
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      link.focus();
    }

    link.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  window.addEventListener('error', function (event) {
    if (event && event.filename && event.filename.indexOf('mapsherpa-product.js') > -1) {
      console.error('[MapSherpa:UNCAUGHT_ERROR]', event.message, 'at', event.filename + ':' + event.lineno);
    }
  });

  window.addEventListener('unhandledrejection', function (event) {
    // Best-effort — only log if it looks related to MapSherpa to avoid noise
    // from unrelated promises elsewhere on the page.
    var reason = event && event.reason ? (event.reason.message || String(event.reason)) : '';
    if (reason && /mapsherpa/i.test(reason)) {
      console.error('[MapSherpa:UNHANDLED_REJECTION]', reason);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    try {
      init();
    initPriceListModal();
    } catch (e) {
      console.error('[MapSherpa] Fatal error during init():', e);
      setMessage('Unable to load the custom map tool. Please refresh the page.', true);
    }
  });

})();
